var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRegionIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7811 5.51299C10.7811 7.83146 4.09546 11.2911 1.91471 10.1503C-0.26645 9.00959 -0.425294 2.09928 1.91471 0.875245C4.25471 -0.348786 10.7811 3.19412 10.7811 5.51299ZM2.2913 1.59512C0.5818 2.48928 0.641519 8.56759 2.2913 9.43046C3.96505 10.3059 9.96861 7.18024 9.96861 5.51299C9.96861 3.79334 4.07596 0.661557 2.2913 1.59512ZM8.74986 5.50853C8.74986 7.05431 4.37861 9.36059 2.95267 8.60009C1.52674 7.83959 1.42233 3.23271 2.95267 2.41696C4.48261 1.60081 8.74986 3.96274 8.74986 5.50812V5.50853ZM3.33455 3.13359C2.41196 3.62596 2.44852 7.41059 3.33455 7.88346C3.68718 8.07115 4.84336 7.81846 6.00483 7.20178C7.14396 6.59687 7.93736 5.82256 7.93736 5.50812C7.93736 5.18231 7.15574 4.39662 6.03774 3.7909C4.87993 3.16365 3.73471 2.9199 3.33496 3.13318L3.33455 3.13359ZM6.31236 5.50324C6.31236 6.08296 4.51268 6.94787 3.92524 6.66268C3.33821 6.37749 3.29555 4.64971 3.92524 4.34381C4.55492 4.0379 6.31236 4.92353 6.31236 5.50324Z",
    fill: "#4F4F4F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegionIcon);
export default __webpack_public_path__ + "static/media/region-icon.a5214f9b61d5c06e2aedbf899c5da7db.svg";
export { ForwardRef as ReactComponent };